import { createTheme, responsiveFontSizes, Theme } from '@mui/material/styles';

export const PRIMARY_COLOR = '#76B82B'; //rgba(50,50,50,.85)
export const SECONDARY_COLOR = '#76B82B';

declare module '@mui/material/styles' {
  interface Palette {
    black: Palette['primary'];
  }
  interface PaletteOptions {
    black?: PaletteOptions['primary'];
  }
  interface PaletteColor {
    black: string;
  }
}

export const customTheme = (): Theme => {
  const muiTheme = createTheme({
    palette: {
      primary: {
        main: PRIMARY_COLOR,
      },
      secondary: {
        main: '#76b82a20',
      },
      black: {
        main: '#000000',
      },
    },
    //"PT Sans",helvetica,arial,sans-serif
    typography: {
      fontFamily: ['Barlow', '"PT Sans"', 'helvetica', 'arial', 'sans-serif'].join(','),
    },
    components: {
      MuiLink: {
        defaultProps: {
          color: 'rgba(50,50,50,.85)',
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            '&.Mui-disabled': {
              background: '#D5DCE6',
              color: '#fff',
              fontWeight: 'bold',
            },
            '&': {
              border: '1px solid #CCCCCC',
            },
          },
        },
        variants: [
          {
            props: {
              variant: 'contained',
            },
            style: {
              color: '#fff',
            },
          },
        ],
      },
    },
  });
  return responsiveFontSizes(muiTheme);
};

export const theme = customTheme();
